import React, { useEffect, useState } from "react";
import Map from "../../components/Googlemap/Map";
import axios from "axios";
import { header } from "../../../../components/api/Header";
import { user_data } from "../../../../components/functions/usr";
import locationred from "../../../../icons/locationred2.png";
import locationgray from "../../../../icons/locationgray2.png";
import editgray from "../../../../icons/editgray.png";
import { getEnv } from "../../../../lib/env";

function BoshSahifa() {
  const [stations, setStations] = useState([]);
  const [data, setData] = useState([]);
  const [info, setInfo] = useState([]);
  const d_id = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 164, 150, 151, 152,
    153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
    60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78,
    79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97,
    98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112,
    113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
    128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142,
    143, 144, 145, 146, 147, 148, 165,
  ];
  const user = user_data();
  const [selectedRowKeys, setSelectedRowKeys] = useState(0);

  useEffect(() => {
    const fetchInfo = async () => {
      const res1 = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') + "/v1/district/info/index",
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
        });
      if (res1) {
        setInfo(res1.data);
      }
    };

    const fetchData = async () => {
      const res = await axios.get(
        `${getEnv('REACT_APP_BASE_URL')}/v1/district/proxy/soatlik`,
        {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
          },
          params: {
            sana: '20231003', // yoki joriy sana o'zgaruvchisi
            region: user.region_id,
            district: d_id[user.district_id]
          }
        }
      );

      if (res && res.data) {
        setStations(res.data.l);
        setData(res.data.d);
      }
    };
    fetchInfo();
    fetchData();
  }, []);

  return (
    <div className="container-fluid h-100">
      <div className="row h-100">
        <div className="col" style={{ position: "relative" }}>
          <div className="mapBlock">
            <Map
              stations={stations}
              center={
                selectedRowKeys
                  ? {
                      lat: parseFloat(data[selectedRowKeys - 1].lat),
                      lng: parseFloat(data[selectedRowKeys - 1].lan),
                    }
                  : { lat: parseFloat(info.lat), lng: parseFloat(info.lng) }
              }
              isfilter={null}
              z={selectedRowKeys ? 20 : 11}
            />
          </div>
        </div>

        <div style={{ width: "300px" }}>
          <div className="details-box-left-change _details-box-left-change h-100">
            <ul className="stations-list">
              <li></li>
              {data.length
                ? data.map((d, i) => {
                    return (
                      <li
                        key={i}
                        className={d.location ? "active-location" : ""}
                        onClick={() => setSelectedRowKeys(i + 1)}
                      >
                        <span>
                          {d.location ? (
                            <img src={locationred} alt="404" />
                          ) : (
                            <img src={locationgray} alt="404" />
                          )}
                          &nbsp;&nbsp;
                          <img src={editgray} alt="404" />
                          &nbsp;&nbsp;
                          {d.name}
                        </span>
                        <span className="text-danger">{d.volume}</span>
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BoshSahifa;
